<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <el-form-item label="所属栏目" prop="columnId">
            <el-cascader :disabled="disabled" size="medium" ref="cascaderColumn" :options="columnTree" :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'dtos' ,checkStrictly: true}" :value="ids" @change="selectChange" clearable placeholder="请选择"></el-cascader>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
            <el-input :disabled="disabled" size="medium" class="inpText" v-model="params.title" placeholder="请输入活动标题"></el-input>
        </el-form-item>
        <!--  缩略图 -->
        <el-form-item label="缩略图" prop="thumbnail">
            <imgs-upload :disabled="disabled" v-model="params.thumbnail" @change="fileChange" tips="（115*70推荐）" limit="1" />
        </el-form-item>
        <!-- 摘要 -->
        <el-form-item label="摘要" prop="summary">
            <el-input :disabled="disabled" style="width:750px;" type="textarea" v-model="params.summary"></el-input>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="内容" prop="content">
            <text-editor :disabled="disabled" style="width:750px;" ref="textEditor" v-model="params.content" />
        </el-form-item>
        <el-form-item label="信息状态" prop="status">
            <el-radio-group v-model="params.status">
                <el-radio :label="2">待审核</el-radio>
                <el-radio :label="3">上线</el-radio>
                <el-radio :label="4">退回</el-radio>
            </el-radio-group>
            <el-input v-if="params.status==4" size="medium" class="inpText" style=" margin-left:10px;" v-model="params.meassage" placeholder="请填写退回意见"></el-input>

        </el-form-item>
    </el-form>
</div>
</template>

<script>
import {

    getColumnTree
} from '@/api/jingshi';
export default {
    props: ['article'],
    data() {
        var checkStatus = function (rule, value, callback,message) {
            console.log(value,message);
            if (!value) {
                return callback(new Error('状态不能为空'));
            } else {
                if (value == 4 && !message) {
                    return callback(new Error('意见不能为空不能为空'));
                } else {
                    return callback();
                }
            }
        };
        return {
            disabled: true,
            params: {
                columnName: '',
                columnId: '',
                content: '', // 内容
                summary: '', // 摘要
                title: '', // 标题
                thumbnail: '',
                status: 0,
                meassage: '',
                pids: '',
            },

            selectData: {},
            columnTree: [],
            ids: [],
            rules: {
                // title: [{
                //     required: true,
                //     message: '文章标题不能为空',
                //     trigger: 'blur'
                // }],
                // content: [{
                //     required: true,
                //     message: '文章内容不能为空',
                //     trigger: 'blur'
                // }],
                // columnId: [{
                //     required: true,
                //     message: '所属栏目不能为空',
                //     trigger: 'blur'
                // }],
                // thumbnail: [{
                //     required: true,
                //     message: '缩略图不能为空',
                //     trigger: 'blur'
                // }],
                // summary: [{
                //     required: true,
                //     message: '摘要不能为空',
                //     trigger: 'blur'
                // }],
                status: [{
                    validator: (rule, value, callback) => {
                        checkStatus(rule, value, callback, this.params.meassage)
                    },
                    trigger: 'blur'
                }],

            }
        }
    },
    watch: {
        article: function (e) {
            if (e) {
                this.params = e;
                // var arr = this.params.pids.split(",").reverse();
                var arr = this.params.pids.split(",");
                console.log(this.params, arr);
                this.ids = arr;
            }
        }
    },
    methods: {

        selectChange: function (e) {
            console.log(e);
            this.ids = e;
            console.log('ids', this.ids);
            var checkLabels = this.$refs['cascaderColumn'].getCheckedNodes();
            console.log(checkLabels, checkLabels[0].label, checkLabels[0].value);
            this.params.columnId = checkLabels[0].value;
            this.params.columnName = checkLabels[0].label;
            this.params.pids = checkLabels[0].data.pids;
        },

        getTreeDataById(data, id) {
            var ret = {};
            for (var i = 0; i < data.length; i++) {
                if (data[i].id === id) {
                    this.selectData = data[i];
                    break;
                } else {
                    if (data[i]['dtos']) {
                        this.getTreeDataById(data[i]['dtos'], id);
                    }
                }
            }
            return;
        },
        handleTree(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]['dtos'].length == 0) {
                    delete data[i].dtos;
                } else {
                    this.handleTree(data[i]['dtos']);
                }
            }
            return data;
        },
        getColumnTree() {
            var vues = this;
            getColumnTree().then(res => {
                vues.columnTree = vues.handleTree(res.cmsColumnLists);
            })
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {

                console.log();
                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var querys = this.$route.query;
        var vues = this;
        this.getColumnTree();
    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner,
.subpage.addrule_edit .el-textarea__inner {
    border-radius: 0px !important;

}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// Subpage1.vue?82386de6